// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OG0wV","inner":"Footer_inner__1CGxS","nextIcon":"Footer_nextIcon__1LpJL","innerLeft":"Footer_innerLeft__2GzKX"};